import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getModuloAll, getModuloAllxArea, setBloqueaModule } from "../../services/modulos";
import IconM from "../dashboard/menu/icons/Icon";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";
import ModuleModal from "./modulemodal";

function ModuleView({ permisos }) {
  const [Area, setArea] = useState([]);
  const [modulos, setModulos] = useState([]);

  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [AreaFId, setAreaFId] = useState(0);
  const [ModuloId, setModuloId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(modulos, page, 10);  
  
  //-- Metodo para mostrar las areas en la grilla
  const fillModulo = async () => 
    {
       setShowToast(false);
    
       const response = await getModuloAll();
       if (response) 
        {
           if (response.status === 200) 
            {
               setModulos(response.data.data);
               setArea(response.data.area);
            } 
           else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
        else 
         {
           const Mensaje = response.message;
           const opc = { type: "Danger", message: Mensaje, active: true };
           setOpciones(opc);
           setShowToast(true);
         }
    };
  
  // boton crear-Editar-Eliminar Area
  const handleCrearModule = (tagId) => 
    {
      if ((selectedRow === null) && (tagId !== 0)) return
        if (tagId === 0) 
         {
           setModuloId(0);
           setAreaId(AreaFId);
         }
          
        setShowM(true);
        setTag(tagId);
    };

  // Bloquea- Desbloquea
  const handleBloqueaModule = async (TagId) => 
    {
       setShowToast(false);
       if ((selectedRow === null) ) return
       const response = await setBloqueaModule(AreaId, ModuloId, TagId);
       if (response) 
        {
           if (response.status === 200) 
            {
               setTag(0);
               setEstado(response.data.data[0].Estado);
               setAreaId(response.data.data[0].AreaId);
               fillModulo();
            } 
           else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
       else 
        {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
    };
  //-- al dar click en la fila
  const handlefilas = (Item, index) => 
      {
         setSelectedRow(index);
         setModuloId(Item.ModuloId);
         setAreaId(Item.AreaId);
         setEstado(Item.Estado);
      };
     
  //-----------------------
  const handleFiltrar =async(area) =>{
      let response=[];
      setAreaFId(area);
      setEstado("AC");
      if (area ===0) 
      { 
        response = await getModuloAll();
      }  
      else 
      { 
        response = await getModuloAllxArea(area);
      }  
      if (response) {
        if (response.status === 200) {
          setModulos(response.data.data);
         
        } else {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
        }
      }   
    }
  //-------------------------------------  
  useEffect(() => 
    {
     setShowM(false);
     fillModulo();
     console.log('permisos:::',permisos)
    }, []);


  return (
    <>
    <div className="">
      <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Modulos</label>
        </div>
        
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearModule(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
       
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearModule(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>

            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearModule(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaModule(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaModule(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}

      </div>
    
    <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
       <table className="w-full table-auto">
          <thead className="border-b border-stone-200 text-sm font-medium ">
              <tr>
                 <th className="px-2.5 py-2 text-start font-medium">Id.</th>
                 <th className="px-2.5 py-2 text-start font-medium">Código</th>
                 <th className="px-2.5 py-2 text-start font-medium">Nombre Modulo</th>
                 <th className="px-2.5 py-2 text-start font-medium">Area</th>
                 <th className="px-2.5 py-2 text-start font-medium">Responsable</th>
                 <th className="px-2.5 py-2 text-start font-medium">Estado</th>
              </tr>
          </thead>
          <tbody className="group text-sm text-stone-800 ">
             {
                slice.map((item, index) => 
                  {
                    return (
                        <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ModuloId}`} onClick={() => handlefilas(item, index)}>
                           <td>
                              <div className="flex w-full pl-1 gap-3 text-sm text-current">
                                  {item.ModuloId}
                              </div>
                            </td>
                            <td>{item.CodigoMod}</td>
                            <td>{item.NombreMod}</td>
                            <td>{item.NombreArea}</td>
                            <td>{item.NombreResp}</td>
                            <td className="center">
                                {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                            </td>
                         </tr>
                       )
                  }
                )
              }
          </tbody>
       </table>
     </div>
        <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
      </div>
     <ModuleModal
       show={showM}
        AreaI={AreaId}
        AreaFId ={AreaFId}
        ModuloI={ModuloId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrar}    
     >
     </ModuleModal>
        
    </>
  );
}
export default ModuleView;
